import { definePermissions } from '@britania/teams-kit-core';
/**
 * Catálogo de permissões do BriDesk: as do kit mais as daqui. É a única
 * lista de chaves que existe. O backend as exige nas rotas
 * (`@RequirePermission`), o frontend as usa para montar a navegação e o banco
 * liga perfis a elas. Uma chave que não está aqui não compila em nenhum dos
 * dois lados.
 *
 * Para integrações (M2M), cada chave também é o `value` de um app role do
 * app no Entra ID (appPackage/aad.manifest.json).
 */
export const PERMISSIONS = definePermissions({
    resources: { Tickets: 'Chamados' },
    permissions: {
        'Tickets.Read': {
            title: 'Ver chamados pendentes',
            description: 'Consulta os chamados do Softdesk que aguardam aprovação.',
        },
    },
});
//# sourceMappingURL=permissions.js.map